<template>
  <div class="home">
    <section class="newgraduate-entrance">
      <router-link to="/newgraduate/lab/" class="lab-entrance-link">
        <section class="lab-entrance">
          <img
            src="../assets/img/front/lab_background.jpg"
            class="cat_background"
          />
          <div class="entrance-title">
            <!-- <p> -->
            研究・技術職種<br />
            希望の方はコチラ
            <KurehaArrow class="kureha_arrow" :width="100" />
            <!-- </p> -->
          </div>
        </section>
      </router-link>
      <router-link to="/newgraduate/gen/" class="gen-entrance-link">
        <section class="gen-entrance">
          <img
            src="../assets/img/front/gen_background.jpg"
            class="cat_background"
          />
          <div class="entrance-title">
            <!-- <p> -->
            企画・営業職種<br />
            希望の方はコチラ
            <KurehaArrow class="kureha_arrow" :width="100" />
            <!-- </p> -->
          </div>
        </section>
      </router-link>
    </section>
    <section class="action">
<router-link to="/info">
  <span>募集要項はこちら</span>
  <img src="@/assets/img/common/arrow-line.svg" alt="" />
</router-link>
    </section>
<!--    <section class="career-entrance">-->
<!--      <a href="http://www.kureha-saiyou.com/" target="_blank">-->
<!--        <div class="entrance-title">-->
<!--          事業所採用 実務推進職系（一般職）はコチラ-->
<!--          <KurehaArrow class="kureha_arrow" :width="105" />-->
<!--        </div>-->
<!--      </a>-->
<!--      <router-link to="/career/info">-->
<!--        <div class="entrance-title">-->
<!--          キャリア採用情報はコチラ-->
<!--          <KurehaArrow class="kureha_arrow" :width="105" />-->
<!--        </div>-->
<!--      </router-link>-->
<!--    </section>-->
<!--    &lt;!&ndash; クレハ検定バナー &ndash;&gt;-->
<!--    <div class="cert_bnr">-->
<!--      <router-link to="/kureha-quiz-test">-->
<!--        <picture>-->
<!--          <source-->
<!--            srcset="../assets/img/kurehaTest/bnr_pc.png"-->
<!--            media="(min-width: 901px)"-->
<!--            width="1780"-->
<!--            height="380"-->
<!--          />-->
<!--          <img-->
<!--            src="../assets/img/kurehaTest/bnr_sp.png"-->
<!--            alt="クレハ検定"-->
<!--            width="1360"-->
<!--            height="413"-->
<!--          />-->
<!--        </picture>-->
<!--      </router-link>-->
<!--    </div>-->
<!--    <section class="common_message">-->
<!--      <h3 class="message_headline">KUREHA Recruiting</h3>-->
<!--      <p>-->
<!--        <img-->
<!--          src="../assets/img/front/nakereba.png"-->
<!--          alt="ナケレバ、ツクレバ。"-->
<!--        />-->
<!--      </p>-->
<!--      <p class="message">-->
<!--        それがクレハのこだわり、それがクレハの開発精神。<br />-->
<!--        独自に開発したモノは、時に形を変え、<br />-->
<!--        役割を変え、人々の暮らしの中で息づいていく。<br />-->
<!--        <em>「どこにも無ければ、創ればいい」</em><br />-->
<!--        世の中が変わっても、その精神は変わらないのです。-->
<!--      </p>-->
<!--    </section>-->
  </div>
</template>

<script>
import KurehaArrow from '@/components/icons/KurehaArrow.vue';

export default {
  name: 'home',
  components: {
    KurehaArrow,
  },
};
</script>

<style scoped lang="scss">
@keyframes shineLeft {
  0% {
    transform: scale(0) rotate(20deg) translateX(0%);
    opacity: 0.1;
  }
  10% {
    transform: scale(10) rotate(20deg) translateX(10%);
    opacity: 0.5;
  }
  41% {
    transform: scale(10) rotate(20deg) translateX(40%);
    opacity: 0.8;
  }
  100% {
    transform: scale(50) rotate(20deg) translateX(100%);
    opacity: 0;
  }
}
@keyframes shineRight {
  0% {
    transform: scale(0) rotate(20deg) translateX(100%);
    opacity: 0.1;
  }
  10% {
    transform: scale(10) rotate(20deg) translateX(40%);
    opacity: 0.5;
  }
  41% {
    transform: scale(10) rotate(20deg) translateX(10%);
    opacity: 0.8;
  }
  100% {
    transform: scale(50) rotate(20deg) translateX(0%);
    opacity: 0;
  }
}
.newgraduate-entrance {
  width: 100%;
  display: flex;
  position: relative;
  background-size: 50%;
  overflow: hidden;
  @media print, screen and (max-width: 900px) {
    flex-direction: column;
  }
  .entrance-title {
    // padding: 10px 20px 10px 50px;
    background-color: rgba(255, 255, 255, 0.8);
    border-radius: 50px;
    position: absolute;
    top: 50%;
    transform: translate(-50%, -50%);
    display: flex;
    line-height: 1.5em;
    font-weight: bold;
    font-size: 24px;
    // padding: 10px 78px 10px 30px;
    width: 100%;
    max-width: 10em;
    padding: 0.5em 2.5em 0.5em 1em;
    @media print, screen and (max-width: 1200px) {
      font-size: 16px;
      max-width: 230px;
      width: 100%;
      padding: 10px 10px 10px 30px;
    }
  }
  .kureha_arrow {
    position: relative;
    margin-left: 20px;
    transition: 0.3s cubic-bezier(0.075, 0.82, 0.165, 1);
    // @media print,screen and (max-width: 900px) {
    top: 0;
    bottom: 0;
    left: auto !important;
    right: 20px;
    position: absolute;
    margin: auto;
    // }
  }
  .cat_background {
    vertical-align: middle;
    transition: 0.3s cubic-bezier(0.075, 0.82, 0.165, 1);
  }
}
.lab-entrance-link,
.gen-entrance-link {
  @media print, screen and (min-width: 901px) {
    transition: 0.3s cubic-bezier(0.075, 0.82, 0.165, 1);
  }
  &:hover {
    // .kureha_arrow {
    //   @media print,screen and (min-width: 901px) {
    //     transform: translateX(20px);
    //   }
    // }
    .cat_background {
      @media print, screen and (min-width: 901px) {
        transform: scale(1.01);
      }
      @media all and (-ms-high-contrast: none) {
        transform: scale(1); //ieの時は背景ズームアニメなし
      }
    }
  }
}
.lab-entrance-link {
  height: 100%;
  width: 66%;
  position: relative;
  overflow: hidden;
  @media print, screen and (min-width: 901px) {
    clip-path: polygon(0 0, 85% 0, 52% 100%, 0% 100%);
  }
  @media print, screen and (max-width: 900px) {
    width: 100%;
  }
  .entrance-title {
    color: #00797f;
    @media print, screen and (min-width: 901px) {
      left: 33%;
    }
    @media print, screen and (max-width: 900px) {
      left: 50%;
    }
  }
  &:before {
    content: ' ';
    background-color: #fff;
    height: 100%;
    left: 0;
    opacity: 0;
    position: absolute;
    top: -180px;
    width: 30px;
    z-index: 2;
  }
  &:hover {
    @media print, screen and (min-width: 901px) {
      z-index: 1;
      opacity: 1 !important;
      clip-path: polygon(0 0, 87% 0, 54% 100%, 0% 100%);
    }
    & + .gen-entrance-link {
      @media print, screen and (min-width: 901px) {
        clip-path: polygon(35% 0, 100% 0, 100% 100%, 2% 100%);
      }
    }
    &:before {
      @media print, screen and (min-width: 901px) {
        animation: 0.5s ease-in-out 0s shineLeft;
      }
    }
  }
}
.gen-entrance-link {
  // background-color: #fff;
  height: 100%;
  width: 66%;
  background-size: auto 100%;
  clip-path: polygon(33% 0, 100% 0, 100% 100%, 0% 100%);
  position: absolute;
  right: 0;
  overflow: hidden;
  @media print, screen and (max-width: 900px) {
    width: 100%;
    margin-top: -30%;
    position: relative;
    clip-path: polygon(0 33%, 100% 0, 100% 100%, 0% 100%);
  }
  &:before {
    content: ' ';
    background-color: #fff;
    height: 100%;
    right: 0;
    opacity: 0;
    position: absolute;
    top: -180px;
    // transform: rotate(45deg);
    width: 30px;
    z-index: 2;
  }
  .entrance-title {
    color: #3fae00;
    left: 55%;
    @media print, screen and (max-width: 900px) {
      left: 50%;
    }
  }
  &:hover {
    opacity: 1 !important;
    @media print, screen and (min-width: 901px) {
      z-index: 1;
      clip-path: polygon(30% 0, 100% 0, 100% 100%, 0% 100%);
    }
    &:before {
      // animation: 2s shine 0s ease-in-out;
      @media print, screen and (min-width: 901px) {
        animation: 0.5s ease-in-out 0s shineRight;
      }
    }
  }
}
.career-entrance {
  // background-color: #3fae00;
  color: #fff;
  text-align: center;
  padding: 30px 0;
  @media print, screen and (max-width: 901px) {
    display: flex;
    flex-direction: column;
  }
  a:nth-child(1) .entrance-title {
    background-color: #00797f;
    width: 500px;
    @media print, screen and (min-width: 901px) {
      margin-right: 30px;
    }
    @media print, screen and (max-width: 901px) {
      margin-bottom: 20px;
    }
  }
  a:nth-child(2) .entrance-title {
    background-color: #3fae00;
    width: 330px;
  }
  .entrance-title {
    box-sizing: border-box;
    font-size: 18px;
    font-weight: bold;
    // border: 2px solid #3fae00;
    display: inline-block;
    border-radius: 50px;
    padding: 5px 88px 5px 20px;
    position: relative;
    @media print, screen and (max-width: 900px) {
      max-width: 500px;
      width: 90% !important;
      font-size: 16px;
      padding: 5px 80px 5px 20px;
    }
    @media print, screen and (max-width: 597px) {
      font-size: 13px;
      padding: 5px 45px 5px 10px;
    }
    @media print, screen and (max-width: 360px) {
      font-size: 11.8px;
      padding: 5px 35px 5px 5px;
    }
  }
  .kureha_arrow {
    left: auto !important;
    right: 20px;
    width: 63px;
    top: 5%;
    margin: auto auto auto 15px;
    @media print, screen and (max-width: 597px) {
      margin: auto auto auto 10px;
      width: 40px;
      right: 10px;
    }
    @media print, screen and (max-width: 360px) {
      width: 30px;
      right: 5px;
    }
  }
}
.common_message {
  text-align: center;
  padding: 100px 0 150px 0;
  width: 90%;
  margin: 0 auto;
  @media print, screen and (max-width: 900px) {
    padding: 50px 0 50px 0;
  }
  .message_headline {
    color: #00797f;
    font-size: 20px;
    margin-bottom: 0;
  }
  img {
    @media print, screen and (min-width: 901px) {
      margin-top: 30px;
    }
    max-width: 567px;
    width: 100%;
  }
  .message {
    font-weight: bold;
    color: #3fae00;
    font-size: 20px;
    letter-spacing: 0.1em;
    @media print, screen and (max-width: 900px) {
      font-size: 14px;
      letter-spacing: 0em;
    }
    em {
      font-size: 36px;
      line-height: 2em;
      @media print, screen and (max-width: 900px) {
        font-size: 18px;
      }
    }
  }
}
@media all and (-ms-high-contrast: none) {
  .lab-entrance-link,
  .gen-entrance-link {
    @media print, screen and (min-width: 901px) {
      width: 50%;
    }
    @media print, screen and (max-width: 900px) {
      margin-top: 0;
    }
    // .kureha_arrow {
    //   position: absolute;
    //   right: 0;
    //   left: unset;
    // }
  }
}

.cert_bnr {
  display: block;
  width: 90%;
  max-width: 500px;
  margin: 0 auto;
  @media print, screen and (min-width: 901px) {
    margin-top: 10px;
    width: 890px;
    max-width: 100%;
  }
  a,
  picture {
    display: block;
    img {
      vertical-align: bottom;
    }
  }
}

.action{
  display: flex;
  align-items: center;
  justify-content: center;

  & > a{
    border: none;
    background: linear-gradient(272.54deg, #3FA800 -9.03%, #00797F 107.82%);
    margin: 72px 0 82px 0;
    display: flex;
    align-items: center;
    justify-content: center;
    column-gap: 40px;
    height: 98px;
    max-width: 556px;
    width: 90%;
    border-radius: 100px;
    & > span{
      font-size: 25px;
      font-weight: 700;
      color: white;
    }

    & > img {
      margin-top: 12px;
    }

    @media print, screen and (max-width: 900px) {
      height: 68px;
      column-gap: 32px;

      & > span{
        font-size: 20px;
      }

      & > img {
        margin-top: 8px;
        height: 12px;
        object-fit: cover;
      }

    }
  }
}
</style>
